import { makeHandlerChainAwaitable, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import {
    chain,
    LoadCartIfNeeded,
} from "@insite/client-framework/Store/Pages/RfqRequestQuote/Handlers/LoadAccountsIfNeeded";

replaceInChain(chain, LoadCartIfNeeded, async props => {
    const currentCart = getCurrentCartState(props.getState()).value;

    // Verndale Customization
    // we need to load the cart if we are being redirect from the OrderConfirmation page, a query string will be present
    const orderConfirmationCartId = window.location.search.includes("cartId");

    if (!currentCart || !currentCart.cartLines || currentCart.cartLines.length > 0 || orderConfirmationCartId) {
        const awaitableLoadCurrentCart = makeHandlerChainAwaitable(loadCurrentCart);
        await awaitableLoadCurrentCart({})(props.dispatch, props.getState);
    }
});
